export default {
  lang_name: 'English',

  // Tabs
  tab_main: 'Main',
  tab_upgrade: 'Upgrade',
  tab_prestige: 'Prestige',
  tab_achievement: 'Achieve',
  tab_mission: 'Mission', tab_domination: 'World', tab_settings: 'Settings',

  // Conquest
  cq_title: 'World Conquest',
  cq_progress: 'Conquered',
  cq_infiltration_power: 'Infiltration Power',
  cq_active_conquest: 'Infiltrating',
  cq_infiltration_progress: 'Infiltration Progress',
  cq_time_remaining: 'Est. Time',
  cq_start_infiltration: 'Start Infiltration',
  cq_stop_infiltration: 'Stop Infiltration',
  cq_no_power_hint: 'Hire agents to generate infiltration power',
  cq_locked: 'Locked',
  cq_available: 'Available',
  cq_conquered: 'Conquered',
  cq_popup_title: 'Conquest Complete!',
  cq_popup_desc: 'has been conquered! Build facilities to grow stronger.',
  cq_back: 'Back',
  cq_invest_title: 'Invest 🛸 to Conquer',
  cq_current_ip: 'Current 🛸',
  cq_facilities: 'Facilities',
  cq_build: 'Build',
  cq_upgrade: 'Upgrade',
  cq_next_level: 'Next',
  cq_counter_intel_title: 'Counter-Intelligence Alert!',
  cq_counter_intel_text: 'Your infiltration in {country} has been detected! Progress will be reduced.',
  cq_defend_ad: 'Watch Ad to Defend',
  cq_accept_loss: 'Accept Loss',
  cq_ending_title: 'Earth Conquered!',
  cq_ending_text: 'The reptilian conspiracy is complete. All nations bow to the shadow empire.',
  cq_ending_time: 'Play Time',
  cq_ending_prestiges: 'Prestiges',
  cq_ending_total_ip: 'Total 🛸',
  cq_ending_taps: 'Total Taps',
  cq_ending_continue: 'Continue Playing',
  // Countries
  cq_egypt: 'Egypt', cq_egypt_desc: 'Ancient pyramid bases',
  cq_brazil: 'Brazil', cq_brazil_desc: 'Amazon jungle hideouts',
  cq_india: 'India', cq_india_desc: 'Naga cult infiltration',
  cq_australia: 'Australia', cq_australia_desc: 'Desert underground bunkers',
  cq_japan: 'Japan', cq_japan_desc: 'Tech theft operations',
  cq_korea: 'Korea', cq_korea_desc: 'NIS cyber defense breach',
  cq_uk: 'United Kingdom', cq_uk_desc: 'MI5/MI6 royal infiltration',
  cq_russia: 'Russia', cq_russia_desc: 'FSB Siberian operations',
  cq_china: 'China', cq_china_desc: 'World\'s strongest surveillance',
  cq_usa: 'United States', cq_usa_desc: 'CIA/NSA final boss',
  // Facilities
  fac_pyramid_vault: 'Pyramid Vault', fac_pyramid_vault_d: '🛸/s +5% per level',
  fac_nile_network: 'Nile Network', fac_nile_network_d: 'Offline +5% per level',
  fac_ancient_lab: 'Ancient Lab', fac_ancient_lab_d: 'TAP +10% per level',
  fac_amazon_hideout: 'Amazon Hideout', fac_amazon_hideout_d: 'Producer discount +2% per level',
  fac_samba_broadcast: 'Samba Broadcast', fac_samba_broadcast_d: '🛸/s +8% per level',
  fac_jungle_lab: 'Jungle Lab', fac_jungle_lab_d: 'Golden event +5% per level',
  fac_naga_temple: 'Naga Temple', fac_naga_temple_d: '💎 +5% per level',
  fac_bollywood_studio: 'Bollywood Studio', fac_bollywood_studio_d: 'Offline +8% per level',
  fac_caste_network: 'Caste Network', fac_caste_network_d: '🛸/s +12% per level',
  fac_desert_bunker: 'Desert Bunker', fac_desert_bunker_d: 'TAP +15% per level',
  fac_ayers_signal: 'Ayers Signal', fac_ayers_signal_d: 'Golden event +8% per level',
  fac_outback_base: 'Outback Base', fac_outback_base_d: '🛸/s +15% per level',
  fac_akiba_ai: 'Akihabara AI', fac_akiba_ai_d: '🛸/s +20% per level',
  fac_ninja_intel: 'Ninja Intel', fac_ninja_intel_d: 'Producer discount +3% per level',
  fac_tokyo_tower: 'Tokyo Tower', fac_tokyo_tower_d: '💎 +8% per level',
  fac_gangnam_hq: 'Gangnam HQ', fac_gangnam_hq_d: '🛸/s +25% per level',
  fac_cyber_command: 'Cyber Command', fac_cyber_command_d: 'TAP +25% per level',
  fac_kpop_brainwash: 'K-Pop Brainwash', fac_kpop_brainwash_d: '💎 +10% per level',
  fac_royal_infiltrate: 'Royal Infiltration', fac_royal_infiltrate_d: '🛸/s +30% per level',
  fac_london_tower: 'London Tower', fac_london_tower_d: 'Offline +15% per level',
  fac_mi6_double: 'MI6 Double Agent', fac_mi6_double_d: 'Golden event +12% per level',
  fac_siberia_base: 'Siberia Base', fac_siberia_base_d: '🛸/s +40% per level',
  fac_kgb_remnant: 'KGB Remnant', fac_kgb_remnant_d: 'Producer discount +5% per level',
  fac_nuke_bunker: 'Nuke Bunker', fac_nuke_bunker_d: 'TAP +40% per level',
  fac_great_wall: 'Great Firewall', fac_great_wall_d: '🛸/s +50% per level',
  fac_shenzhen_factory: 'Shenzhen Factory', fac_shenzhen_factory_d: 'Producer discount +8% per level',
  fac_panda_spy: 'Panda Spy Ring', fac_panda_spy_d: 'Golden event +20% per level',
  fac_area51: 'Area 51', fac_area51_d: '🛸/s +80% per level',
  fac_pentagon: 'Pentagon', fac_pentagon_d: 'TAP +80% per level',
  fac_wall_street: 'Wall Street', fac_wall_street_d: '💎 +25% per level',

  // HUD
  hud_cps: '/s',
  hud_boost: 'Boost',

  // Main screen
  main_tap_area: 'TAP!',
  main_combo: 'Combo',

  // Producers
  prod_informant: 'Informant',
  prod_informant_desc: 'Street-level intel gathering',
  prod_hacker: 'Hacker',
  prod_hacker_desc: 'Human network infiltration',
  prod_disguiser: 'Disguiser',
  prod_disguiser_desc: 'Human form camouflage',
  prod_mindController: 'Mind Controller',
  prod_mindController_desc: 'Human opinion manipulation',
  prod_secretLab: 'Secret Lab',
  prod_secretLab_desc: 'Reptilian tech research',
  prod_mediaCell: 'Media Cell',
  prod_mediaCell_desc: 'News & SNS takeover',
  prod_shadowGovt: 'Shadow Govt',
  prod_shadowGovt_desc: 'Politician replacement ops',
  prod_deepBase: 'Deep Base',
  prod_deepBase_desc: 'Underground mega-base',
  prod_orbitalStation: 'Orbital Station',
  prod_orbitalStation_desc: 'Satellite surveillance net',
  prod_dimensionGate: 'Dimension Gate',
  prod_dimensionGate_desc: 'Summon forces from homeworld',
  prod_planetController: 'Planet Controller',
  prod_planetController_desc: 'Direct Earth system control',
  prod_galacticBeacon: 'Galactic Beacon',
  prod_galacticBeacon_desc: 'Direct line to HQ',
  prod_locked: 'Unlock: ',
  prod_locked_prestige: 'Prestige {n}x',
  prod_locked_time: '{n}min play',

  // Milestones
  milestone_squad: 'Squad Formation',
  milestone_company: 'Company Complete',
  milestone_battalion: 'Battalion Force',
  milestone_regiment: 'Regiment Force',
  milestone_division: 'Division Force',
  milestone_corps: 'Corps Force',

  // Click upgrades
  click_basic_training: 'Basic Training',
  click_combat_training: 'Combat Training',
  click_psychic_awaken: 'Psychic Awakening',
  click_transform: 'Transform Enhance',
  click_telepathy: 'Telepathy', click_critical_eye: 'Critical Eye',
  click_dimension_sense: 'Dimension Sense', click_galaxy_field: 'Galaxy Field',
  click_lethal_strike: 'Lethal Strike', click_absolute: 'Absolute Infiltration',
  click_planet_destroyer: 'Planet Destroyer',
  click_galaxy_finger: "Galaxy Overlord's Finger",

  // Special upgrades
  special_info_network: 'Info Network',
  special_info_network_desc: 'Informant & Hacker x2',
  special_perfect_disguise: 'Perfect Disguise',
  special_perfect_disguise_desc: 'All agents x1.5',
  special_mass_brainwash: 'Mass Brainwash',
  special_mass_brainwash_desc: 'Mind Controller & Media x3',
  special_shadow_network: 'Shadow Network',
  special_shadow_network_desc: 'Offline income +25%',
  special_underground_empire: 'Underground Empire',
  special_underground_empire_desc: 'All agents x2',
  special_orbital_surveillance: 'Orbital Surveillance',
  special_orbital_surveillance_desc: 'Golden events +50% freq',
  special_dimension_supply: 'Dimension Supply Line',
  special_dimension_supply_desc: 'Tap income x5',
  special_galactic_alliance: 'Galactic Alliance',
  special_galactic_alliance_desc: '🛸 per second x10',
  special_combo_master: 'Combo Master',
  special_combo_master_desc: 'Combo cap x3',
  special_time_warp: 'Time Warp',
  special_time_warp_desc: 'Offline cap 12h',
  special_agent_synergy: 'Agent Synergy',
  special_agent_synergy_desc: '🛸 per second x1.5',
  special_massive_infiltration: 'Massive Infiltration',
  special_massive_infiltration_desc: '🛸 per second x2',

  // Sub tabs
  subtab_click: 'Click',
  subtab_special: 'Special',

  // Prestige
  prestige_title: 'Organization Restructure',
  prestige_total_ip: 'Total 🛸 earned',
  prestige_gc_gain: '💎 to gain',
  prestige_gc_current: 'Current 💎',
  prestige_execute: 'Restructure',
  prestige_confirm: 'Reset all progress for {gc} Galactic Credits?',
  prestige_ad_bonus: 'Watch ad for +50% 💎',
  prestige_requirement: 'Need 10B+ 🛸 to prestige',
  prestige2_title: 'Galaxy Restructure',
  prestige2_cores_gain: '🔮 to gain',
  prestige2_cores_current: 'Current 🔮',
  prestige2_execute: 'Galaxy Restructure',
  prestige2_requirement: 'Need 15+ prestiges & 100+ total 💎',
  prestige2_confirm: 'Deep reset everything for {cores} Galaxy Cores?',

  // Prestige upgrades
  pup_galaxy_mult: 'Galaxy Multiplier',
  pup_galaxy_mult_desc: 'CPS x1.5 per level (stacks multiplicatively)',
  pup_infil_accel: 'Infiltration Accel',
  pup_infil_accel_desc: 'Start with 100M 🛸 per level after prestige',
  pup_tap_enhance: 'Tap Enhance',
  pup_tap_enhance_desc: 'Tap income x2 per level (stacks multiplicatively)',
  pup_offline_expand: 'Offline Expand',
  pup_offline_expand_desc: 'Offline reward cap +1h/Lv (base 8h)',
  pup_offline_eff: 'Offline Efficiency',
  pup_offline_eff_desc: 'Offline income rate +10%p/Lv (base 50%)',
  pup_agent_discount: 'Agent Discount',
  pup_agent_discount_desc: 'Agent hire cost -10% per level (max -50%)',
  pup_auto_click: 'Auto Click',
  pup_auto_click_desc: 'Auto-tap 3 times/sec per level (max 15/sec)',
  pup_golden_luck: 'Golden Luck',
  pup_golden_luck_desc: 'Golden event reward +20%/Lv (max +200%)',
  pup_combo_keep: 'Combo Keep',
  pup_combo_keep_desc: 'Combo timer +0.5s/Lv (base 2s)',
  pup_quick_start: 'Quick Start',
  pup_quick_start_desc: 'Auto-grant 1 of each first 5 agents after prestige',

  // Prestige 2 upgrades
  p2up_galaxy_speed: 'Galaxy Speed',
  p2up_galaxy_speed_desc: '💎 gain x2 per level on prestige (stacks multiplicatively)',
  p2up_auto_prestige: 'Auto Prestige',
  p2up_auto_prestige_desc: 'Auto-prestige when reaching 10B 🛸',
  p2up_permanent: 'Permanent Agents',
  p2up_permanent_desc: 'Keep first 3 agent types after prestige',
  p2up_dimension_accel: 'Dimension Accel',
  p2up_dimension_accel_desc: 'CPS x5 per level (stacks, permanent)',
  p2up_galaxy_memory: 'Galaxy Memory',
  p2up_galaxy_memory_desc: 'Keep 3 active boosts through prestige',
  p2up_spacetime: 'Spacetime Warp',
  p2up_spacetime_desc: 'Offline income rate set to 100% (permanent)',
  p2up_automate: 'Galaxy Automate',
  p2up_automate_desc: 'Auto-hire agents (permanent)',

  // Ranks
  rank_e: 'Intern',
  rank_d: 'Junior Agent',
  rank_c: 'Agent',
  rank_b: 'Senior Agent',
  rank_a: 'Executive',
  rank_s: 'Director',
  rank_ss: 'Supreme Cmdr',
  rank_sss: 'Galactic Overlord',

  // Achievements
  ach_title: 'Achievements',
  ach_filter_all: 'All',
  ach_filter_tap: 'Tap',
  ach_filter_resource: 'Resource',
  ach_filter_producer: 'Producer',
  ach_filter_prestige: 'Prestige',
  ach_filter_time: 'Time',
  ach_filter_special: 'Special',
  ach_filter_ad: 'Docs',
  ach_filter_combo: 'Combo',

  ach_t01: 'First Step', ach_t01_reward: '+1 Tap Power',
  ach_t02: 'Finger Warmup', ach_t02_reward: '+5% Tap Power',
  ach_t03: 'Steady Agent', ach_t03_reward: '+10% Tap Power',
  ach_t04: 'Touch Master', ach_t04_reward: '+15% Tap Power',
  ach_t05: 'Reptilian Grit', ach_t05_reward: '+20% Tap Power',
  ach_t06: 'Galaxy Fingers', ach_t06_reward: '+25% Tap Power',
  ach_t07: 'Combo Apprentice', ach_t07_reward: '+0.5s Combo',
  ach_t08: 'Combo Master', ach_t08_reward: '+0.5 Combo Cap',

  ach_r01: 'Small Intel', ach_r01_reward: '+5% 🛸/s',
  ach_r02: 'Intel Collector', ach_r02_reward: '+5% 🛸/s',
  ach_r03: 'Classified Vault', ach_r03_reward: '+5% 🛸/s',
  ach_r04: 'Million Infiltrate', ach_r04_reward: '+10% 🛸/s',
  ach_r05: 'Billion Agent', ach_r05_reward: '+10% 🛸/s',
  ach_r06: 'Trillion Ops', ach_r06_reward: '+15% 🛸/s',
  ach_r07: 'Quadrillion Empire', ach_r07_reward: '+15% 🛸/s',
  ach_r08: 'Galaxy Ocean', ach_r08_reward: '+20% 🛸/s',
  ach_r09: 'Cosmic Universe', ach_r09_reward: '+20% 🛸/s',
  ach_r10: 'Infinite Infiltrate', ach_r10_reward: '+30% 🛸/s',

  ach_g01: 'First Recruit', ach_g01_reward: 'Informant x1.5',
  ach_g02: 'Intel Network', ach_g02_reward: 'Informant x2',
  ach_g03: 'Hacking Begins', ach_g03_reward: 'Hacker x2',
  ach_g04: 'Cyber Legion', ach_g04_reward: 'Hacker x3',
  ach_g05: 'Master of Disguise', ach_g05_reward: 'Disguiser x2',
  ach_g06: 'Brainwash Net', ach_g06_reward: 'Mind Controller x2',
  ach_g07: 'Mad Science', ach_g07_reward: 'Secret Lab x2',
  ach_g08: 'Media Control', ach_g08_reward: 'Media Cell x2',
  ach_g09: 'Shadow Cabinet', ach_g09_reward: 'Shadow Govt x2',
  ach_g10: 'Underground Empire', ach_g10_reward: 'Deep Base x2',
  ach_g11: 'Orbital Dominance', ach_g11_reward: 'Orbital Station x2',
  ach_g12: 'Master of Galaxy', ach_g12_reward: 'Total 🛸/s x2',

  ach_p01: 'First Restructure', ach_p01_reward: '+5 💎 Bonus',
  ach_p02: 'Taste of Cycle', ach_p02_reward: '+10% 💎',
  ach_p03: 'Veteran Agent', ach_p03_reward: '+10% 💎',
  ach_p04: 'Prestige Addict', ach_p04_reward: '+15% 💎',
  ach_p05: 'Infinite Loop', ach_p05_reward: '+20% 💎',
  ach_p06: 'Galaxy Memory', ach_p06_reward: '+25% 💎',
  ach_p07: 'Galaxy Restructure', ach_p07_reward: '+3 🔮 Bonus',
  ach_p08: 'Dimension Lord', ach_p08_reward: '+20% 🔮',

  ach_h01: 'New Recruit', ach_h01_reward: 'Welcome Bonus 100 🛸',
  ach_h02: '1 Hour Shift', ach_h02_reward: '+5% 🛸/s',
  ach_h03: 'Half Day', ach_h03_reward: '+10% 🛸/s',
  ach_h04: '24h Stakeout', ach_h04_reward: 'Offline +2h',
  ach_h05: '3 Day Mission', ach_h05_reward: '🛸/s x1.5',
  ach_h06: 'Week Infiltration', ach_h06_reward: '🛸/s x2',

  ach_s01: 'Suspicious Human', ach_s01_reward: '1 Doc',
  ach_s02: 'Clean Start', ach_s02_reward: 'Title: Reckless Agent',
  ach_s03: 'All In', ach_s03_reward: '+10% 🛸/s',
  ach_s04: 'Speed Run', ach_s04_reward: '+10 💎 Bonus',
  ach_s05: 'Golden Hunter', ach_s05_reward: 'Event freq -20%',
  ach_s06: 'Night Agent', ach_s06_reward: 'Night 🛸/s x1.5',
  ach_s07: 'F2P Warrior', ach_s07_reward: 'Ad reward +30%',
  ach_s08: 'Collector', ach_s08_reward: '🛸/s x3',

  ach_a01: 'Ad Beginner', ach_a01_reward: '1 Doc',
  ach_a02: 'Ad Enthusiast', ach_a02_reward: '2 Docs',
  ach_a03: 'Ad Master', ach_a03_reward: 'Ad reward +30%',
  ach_a04: 'Doc Collector', ach_a04_reward: 'Doc effect +20%',
  ach_a05: 'Doc Expert', ach_a05_reward: 'Doc effect +50%',

  ach_c01: 'Combo Start', ach_c01_reward: '+0.3s Combo',
  ach_c02: 'Riding Rhythm', ach_c02_reward: '+0.1 Combo mult',
  ach_c03: 'Golden Beginner', ach_c03_reward: 'Event reward +10%',
  ach_c04: 'Golden Collector', ach_c04_reward: 'Event freq -10%',
  ach_c05: 'Daily Maniac', ach_c05_reward: 'Mission reward +50%',

  // Golden events
  golden_intel_leak: 'Intel Leak!',
  golden_agent_frenzy: 'Agent Frenzy!',
  golden_money_launder: 'Money Laundering!',
  golden_facility_boost: 'Facility Overdrive!',
  golden_supply_drop: 'Galaxy Supply Drop!',
  golden_touch: 'TAP!',
  golden_ad_double: 'Watch ad for 2x',

  // Offline
  offline_title: 'Absence Report',
  offline_elapsed: 'Time elapsed',
  offline_earned: '🛸 earned',
  offline_cap: 'Max {h}h applied',
  offline_claim: 'Claim',
  offline_double: 'Watch ad for 2x ({amount})',
  offline_hours: '{h}h {m}m',

  // Settings
  settings_title: 'Settings',
  settings_bgm: 'BGM',
  settings_sfx: 'SFX',
  settings_lang: 'Language',
  settings_reset: 'Reset Game',
  settings_reset_confirm: 'Delete ALL progress and start over?',
  settings_stats: 'Statistics',
  settings_total_ip: 'Total 🛸 Earned',
  settings_total_taps: 'Total Taps',
  settings_total_prestiges: 'Total Prestiges',
  settings_play_time: 'Total Play Time',
  settings_docs_shop: 'Classified Docs Shop',

  // Doc shop
  doc_shop_title: 'Classified Docs Shop',
  doc_ip_boost: 'Auto Income Boost', doc_ip_boost_desc: '2x 🛸/s production for 30 seconds',
  doc_mega_tap: 'Power Tap Training', doc_mega_tap_desc: '3x tap income for 30 seconds',
  doc_auto_click: 'Auto-Infiltrator', doc_auto_click_desc: 'Auto-tap 10 times/sec for 30 seconds',
  doc_instant_golden: 'Emergency Golden Call', doc_instant_golden_desc: 'Trigger golden event instantly',
  doc_timeskip: 'Time Accelerator', doc_timeskip_desc: 'Instantly earn 2 hours of 🛸 income',
  doc_prestige_boost: 'Galaxy Amplifier', doc_prestige_boost_desc: '2x 💎 gain on next prestige',
  doc_prestige_boost_active: '💎 x2 pending for next prestige', doc_prestige_boost_active_badge: '✅ Active',

  // Ad rewards
  ad_offline_double: 'Double offline reward',
  ad_cps_boost: '/sec income x10 Boost (15s)',
  ad_prestige_bonus: 'Prestige +50% 💎',
  ad_timeskip: 'Time Skip (2h)',
  ad_free_docs: 'Free Classified Docs',
  ad_golden_double: 'Double golden reward',
  ad_start_boost: 'Start Boost Pack',
  ad_watching: 'Loading ad...',
  ad_cooldown: 'Available in {t}',
  settings_sfx_test: 'Test SFX',
  settings_sound_reset: 'Reset',
  settings_sound_reset_done: 'Sound reset to default',

  // Numbers
  num_k: 'K',
  num_m: 'M',
  num_b: 'B',
  num_t: 'T',
  num_qa: 'Qa',
  num_qi: 'Qi',
  num_sx: 'Sx',
  num_sp: 'Sp',
  num_oc: 'Oc',
  num_no: 'No',
  num_dc: 'Dc',

  // Daily Missions
  mission_title: 'Daily Missions',
  mission_claim: 'Claim',
  mission_all_complete: 'All Complete Bonus!',
  mission_clear_label: 'MISSION',
  mission_all_clear_label: 'ALL CLEAR',
  ach_unlock_label: 'ACHIEVEMENT',
  mission_diff_easy: 'Easy',
  mission_diff_normal: 'Med',
  mission_diff_hard: 'Hard',
  mission_tap_100: 'Light Touch',
  mission_tap_100_desc: 'Tap 100 times',
  mission_tap_300: 'Warm Hands',
  mission_tap_300_desc: 'Tap 300 times',
  mission_buy_5: 'Small Recruit',
  mission_buy_5_desc: 'Buy 5 producers',
  mission_combo_10: 'Combo Starter',
  mission_combo_10_desc: 'Reach 10 combo',
  mission_golden_1: 'Lucky Catch',
  mission_golden_1_desc: 'Catch 1 golden event',
  mission_tap_1000: 'Heavy Hitter',
  mission_tap_1000_desc: 'Tap 1,000 times',
  mission_buy_20: 'Squad Builder',
  mission_buy_20_desc: 'Buy 20 producers',
  mission_combo_50: 'Combo Pro',
  mission_combo_50_desc: 'Reach 50 combo',
  mission_golden_3: 'Gold Rush',
  mission_golden_3_desc: 'Catch 3 golden events',
  mission_earn_1m: 'Million Ops',
  mission_earn_1m_desc: 'Earn 1M 🛸',
  mission_tap_5000: 'Tap Machine',
  mission_tap_5000_desc: 'Tap 5,000 times',
  mission_buy_50: 'Army Builder',
  mission_buy_50_desc: 'Buy 50 producers',
  mission_combo_100: 'Combo God',
  mission_combo_100_desc: 'Reach 100 combo',
  mission_golden_5: 'Golden Master',
  mission_golden_5_desc: 'Catch 5 golden events',
  mission_earn_1b: 'Billion Agent',
  mission_earn_1b_desc: 'Earn 1B 🛸',
  // New missions
  mission_tap_200: 'Quick Fingers',
  mission_tap_200_desc: 'Tap 200 times',
  mission_buy_3: 'First Recruits',
  mission_buy_3_desc: 'Buy 3 producers',
  mission_combo_15: 'Combo Beginner',
  mission_combo_15_desc: 'Reach 15 combo',
  mission_earn_10k: 'Pocket Money',
  mission_earn_10k_desc: 'Earn 10K 🛸',
  mission_earn_100k: 'Fund Raiser',
  mission_earn_100k_desc: 'Earn 100K 🛸',
  mission_tap_500: 'Steady Tapper',
  mission_tap_500_desc: 'Tap 500 times',
  mission_tap_700: 'Relentless',
  mission_tap_700_desc: 'Tap 700 times',
  mission_buy_10: 'Team Leader',
  mission_buy_10_desc: 'Buy 10 producers',
  mission_combo_30: 'Combo Chain',
  mission_combo_30_desc: 'Reach 30 combo',
  mission_golden_2: 'Double Gold',
  mission_golden_2_desc: 'Catch 2 golden events',
  mission_tap_3000: 'Tap Warrior',
  mission_tap_3000_desc: 'Tap 3,000 times',
  mission_buy_30: 'Battalion',
  mission_buy_30_desc: 'Buy 30 producers',
  mission_combo_75: 'Combo Elite',
  mission_combo_75_desc: 'Reach 75 combo',
  mission_golden_4: 'Gold Hunter',
  mission_golden_4_desc: 'Catch 4 golden events',
  mission_earn_10m: 'Tycoon',
  mission_earn_10m_desc: 'Earn 10M 🛸',

  // Misc
  buy: 'Buy',
  max: 'MAX',
  level: 'Lv.',
  locked: 'Locked',
  upgrade_locked_prev: 'Learn the previous upgrade first',
  unlocked: 'Unlocked',
  condition: 'Condition',
  cost: 'Cost',
  owned: 'Owned',
  effect: 'Effect',
  reward: 'Reward',
  close: 'Close',
  confirm: 'Confirm',
  cancel: 'Cancel',

  // Conquest achievements
  ach_filter_conquest: 'Conquest',
  ach_q01: 'First Conquest', ach_q01_reward: '+10% 🛸/s',
  ach_q02: 'Triple Threat', ach_q02_reward: '+10% TAP',
  ach_q03: 'Half the World', ach_q03_reward: '+15% 💎',
  ach_q04: 'Seven Flags', ach_q04_reward: '+20% Offline',
  ach_q05: 'World Dominator', ach_q05_reward: '🛸/s x3',
  ach_q06: 'Facility Master', ach_q06_reward: '🛸/s x2',
  milestone_next: 'Next',
  settings_conquest: 'Conquest',

  // Currency info
  currency_ip_name: 'Infiltration Points (IP)',
  currency_ip_earn: 'Earn by tapping, agent auto-production, offline income, and ad rewards',
  currency_ip_use: 'Hire agents, buy upgrades, invest in country conquest',
  currency_gc_name: 'Galactic Credits (GC)',
  currency_gc_earn: 'Earned by prestiging (Organization Restructure) based on total IP',
  currency_gc_use: 'Buy prestige upgrades (production multiplier, offline efficiency, etc.)',
  currency_cores_name: 'Galaxy Cores',
  currency_cores_earn: 'Earned by 2nd prestige (Galaxy Restructure) based on total GC',
  currency_cores_use: 'Buy 2nd prestige upgrades (permanent buffs, automation, etc.)',
  currency_docs_name: 'Classified Docs',
  currency_docs_earn: 'Complete daily missions, watch ads, or unlock achievements',
  currency_docs_use: 'Buy powerful boosts in the Doc Shop (Mission tab)',
  currency_how_earn: 'How to earn',
  currency_how_use: 'How to use',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: 'Infiltration Mastery',
  pup_infiltration_mastery_desc: 'Total infiltration power +50%/Lv (max +500%)',
  pup_agent_network: 'Agent Network',
  pup_agent_network_desc: 'Infiltration +5% per 100 agents per level',
  pup_quick_infiltration: 'Chain Infiltration',
  pup_quick_infiltration_desc: 'Next country starts with +10% progress/Lv on conquest',
  pup_critical_chance: 'Critical Training',
  pup_critical_chance_desc: 'Tap crit chance +3%/Lv (base 10%, max 50%)',
  pup_critical_damage: 'Critical Power',
  pup_critical_damage_desc: 'Crit damage +1x/Lv (base x3)',

  // Special upgrades - conquest
  special_spy_master: 'Spy Master',
  special_spy_master_desc: 'All infiltration power x2',

  ad_income_x5: 'Get 30min Income',
  ad_income_x5_desc: 'Watch an ad to instantly earn\n{amount} 🛸 (30 minutes of income)!',
  ad_tap_x10: 'Tap x10 (10s)',
  ad_tap_x10_desc: 'Watch an ad to boost\ntap income by 10x for 10 seconds!',
  ad_free_docs_desc: 'Watch an ad to get\n1 free Classified Document 📜!',
  ad_prestige_desc: 'Watch an ad to boost\nincome by 10x for 15 seconds!',
  cq_tutorial_title: '🌍 World Conquest Guide',
  cq_tutorial_text: 'After conquering a country, you can build <b>facilities</b>!\nUpgrade them for permanent bonuses like\n<b>🛸/s, tap income, offline income</b> and more.\n\nHire agents to increase infiltration power.',
  rank_promote: 'Promote',
  rank_promoted: 'Promoted!',

  // Boss events
  boss_resistance_captain: 'Resistance Captain',
  boss_resistance_captain_desc: 'Human militia leader, veteran fighter',
  boss_cia_agent: 'CIA Agent',
  boss_cia_agent_desc: 'Covert operative with classified intel',
  boss_mib_investigator: 'MIB Investigator',
  boss_mib_investigator_desc: 'Men In Black field agent',
  boss_un_inspector: 'UN Inspector',
  boss_un_inspector_desc: 'International conspiracy hunter',
  boss_whistleblower: 'Whistleblower',
  boss_whistleblower_desc: 'Rogue insider with proof',
  boss_journalist: 'Investigative Journalist',
  boss_journalist_desc: 'Relentless truth-seeker with a camera',
  boss_truth_seeker: 'Truth Seeker',
  boss_truth_seeker_desc: 'Paranormal researcher on the trail',
  boss_galactic_guardian: 'Galactic Guardian',
  boss_galactic_guardian_desc: 'Cosmic enforcer of universal law',

  boss_alert: 'THREAT DETECTED!',
  boss_alert_desc: 'An enemy has appeared! Tap to attack!',
  boss_hp: 'HP',
  boss_tap_attack: 'TAP TO ATTACK!',
  boss_double_damage: '2x DMG (30s)',
  boss_eliminated: 'ELIMINATED!',
  boss_eliminated_desc: '{name} has been neutralized!',
  boss_reward_ip: '+{amount} IP',
  boss_reward_docs: '+{amount} Docs',
  boss_reward_gc: '+{amount} GC',
  boss_reward_boost: 'CPS x3 ({seconds}s)',
  boss_claim: 'Claim Reward',
  boss_claim_double: '2x Reward',
  boss_escaped: 'ESCAPED!',
  boss_escaped_desc: 'The target got away...',
  boss_revive: 'Retry (+20s)',
  boss_phase2: 'ENRAGED!',
  boss_streak: 'Kill Streak: {n}',
  boss_time_remaining: 'Time',
  boss_double_damage_active: '2x DMG Active!',

  // Agent collection
  tab_agent: 'Agents',
  agent_collection_title: 'Agent Collection',
  agent_equipped: 'Equipped',
  agent_empty_slot: 'Empty',
  agent_obtained: 'Agent Obtained!',
  agent_equip: 'Equip',
  agent_unequip: 'Unequip',
  agent_locked: '???',
  agent_count: 'x{n}',
  agent_tutorial_title: 'Agent Collection Guide',
  agent_tutorial_text: 'Defeat <b>bosses</b> to collect agent cards!<br><br>Each agent has a unique passive bonus.<br>Equip agents by tapping their card.<br><br>Higher rarity = stronger effects.<br>Prestige unlocks more equip slots.',

  // Agent effect descriptions
  agent_effect_cps_pct: 'CPS {n}',
  agent_effect_tap_pct: 'TAP {n}',
  agent_effect_conquest_speed: 'Conquest Speed {n}',
  agent_effect_boss_damage: 'Boss DMG {n}',
  agent_effect_golden_chance: 'Golden Event {n}',
  agent_effect_offline_pct: 'Offline Income {n}',
  agent_effect_docs_rate: 'Doc Rate {n}',
  agent_effect_gc_pct: 'GC Gain {n}',
  agent_effect_boss_spawn_reduce: 'Boss Spawn -{n}',
  agent_effect_prestige_gc_bonus: 'Prestige GC {n}',
  agent_effect_faction_favor: 'Faction Favor {n}',

  // Agent names & descriptions (25 agents)
  // Common (10)
  agent_field_spy: 'Field Spy',
  agent_field_spy_desc: 'Field intel boosts IP production +8%',
  agent_code_cracker: 'Code Cracker',
  agent_code_cracker_desc: 'Decryption skills boost tap power +10%',
  agent_shadow_runner: 'Shadow Runner',
  agent_shadow_runner_desc: 'Stealth expertise speeds conquest +10%',
  agent_data_miner: 'Data Miner',
  agent_data_miner_desc: 'Data harvesting boosts offline income +15%',
  agent_lookout: 'Lookout',
  agent_lookout_desc: 'Keen eyes boost golden event chance +10%',
  agent_doc_thief: 'Doc Thief',
  agent_doc_thief_desc: 'Document theft boosts doc acquisition +15%',
  agent_network_bot: 'Network Bot',
  agent_network_bot_desc: 'Automated networks boost CPS +10%',
  agent_safe_cracker: 'Safe Cracker',
  agent_safe_cracker_desc: 'Vault skills boost tap power +12%',
  agent_recruit: 'Recruit',
  agent_recruit_desc: 'Fresh fighter boosts boss damage +10%',
  agent_comm_officer: 'Comm Officer',
  agent_comm_officer_desc: 'Communications boost faction favor +10%',

  // Rare (8)
  agent_infiltration_ace: 'Infiltration Ace',
  agent_infiltration_ace_desc: 'Elite infiltrator boosts CPS +20%',
  agent_mind_bender: 'Mind Bender',
  agent_mind_bender_desc: 'Psychic powers speed conquest +25%',
  agent_vault_raider: 'Vault Raider',
  agent_vault_raider_desc: 'Vault expertise boosts GC gain +20%',
  agent_signal_jammer: 'Signal Jammer',
  agent_signal_jammer_desc: 'Jamming reduces boss spawn delay -15%',
  agent_double_agent: 'Double Agent',
  agent_double_agent_desc: 'Dual allegiance boosts offline income +30%',
  agent_hive_mind: 'Hive Mind',
  agent_hive_mind_desc: 'Collective consciousness boosts doc rate +25%',
  agent_boss_hunter: 'Boss Hunter',
  agent_boss_hunter_desc: 'Specialized tracker boosts boss damage +25%',
  agent_faction_liaison: 'Faction Liaison',
  agent_faction_liaison_desc: 'Diplomatic ties boost faction favor +25%',

  // Epic (5)
  agent_reptilian_elite: 'Reptilian Elite',
  agent_reptilian_elite_desc: 'Elite warrior boosts CPS +35%',
  agent_galaxy_commander: 'Galaxy Commander',
  agent_galaxy_commander_desc: 'Galactic authority boosts GC gain +40%',
  agent_dark_secretary: 'Dark Secretary',
  agent_dark_secretary_desc: 'Shadow bureaucrat boosts prestige GC +20%',
  agent_omega_operative: 'Omega Operative',
  agent_omega_operative_desc: 'Ultimate fighter boosts boss damage +50%',
  agent_shapeshifter: 'Shapeshifter',
  agent_shapeshifter_desc: 'Master of forms boosts tap power +40%',

  // Legendary (2)
  agent_the_overlord: 'The Overlord',
  agent_the_overlord_desc: 'Supreme commander boosts all CPS +50%',
  agent_grand_architect: 'Grand Architect',
  agent_grand_architect_desc: 'Cosmic planner speeds conquest +60%',
  // Faction system
  faction_status_title: 'Faction Status',
  faction_favorability: 'Favorability',
  faction_tier: 'Tier {n}',

  // Faction event popup
  faction_event_help: 'Help',
  faction_event_ignore: 'Ignore',
  faction_event_timer: '{seconds}s remaining',
  faction_event_reward: '+{favor} {faction} favor, -{loss} {target} favor',
  faction_event_ip_reward: '+{amount} IP reward',
  faction_event_ad_bonus: 'Watch Ad: +{n} {faction} favor',

  // Faction names
  faction_illuminati: 'Illuminati',
  faction_illuminati_desc: 'Secret human rulers pulling strings from the shadows',
  faction_grey: 'Grey Aliens',
  faction_grey_desc: 'Technology-sharing extraterrestrial species',
  faction_mib: 'MIB Resistance',
  faction_mib_desc: 'Secret human organization fighting alien influence',

  // Faction bonus descriptions
  faction_illuminati_bonus1: 'CPS +10%',
  faction_illuminati_bonus2: 'CPS +15%',
  faction_illuminati_bonus3: 'Conquest Speed +20%',
  faction_grey_bonus1: 'Tap +15%',
  faction_grey_bonus2: 'Tap +20%',
  faction_grey_bonus3: 'Golden Cookie +25%',
  faction_mib_bonus1: 'Boss Damage +20%',
  faction_mib_bonus2: 'Offline Earnings +15%',
  faction_mib_bonus3: 'Boss Spawn -15%',

  // Event titles and descriptions (15 events)
  event_illu_decode_title: 'Classified Interception',
  event_illu_decode_desc: 'The Illuminati are intercepting classified government files. Help decode them?',
  event_illu_stock_title: 'Market Manipulation',
  event_illu_stock_desc: 'The Illuminati want to manipulate global stock markets. Provide insider intel?',
  event_illu_surveillance_title: 'Surveillance Network',
  event_illu_surveillance_desc: 'The Illuminati are building a secret surveillance network. Assist construction?',
  event_illu_meeting_title: 'Secret Summit',
  event_illu_meeting_desc: 'A secret Illuminati meeting at a world leaders\' gathering. Provide security?',
  event_illu_bribe_title: 'Alien Diplomacy',
  event_illu_bribe_desc: 'The Illuminati want to bribe an alien diplomat. Deliver the package?',

  event_grey_experiment_title: 'Human Research',
  event_grey_experiment_desc: 'Grey Aliens are conducting experiments on humans. Guard the lab?',
  event_grey_mindcontrol_title: 'Mind Control Device',
  event_grey_mindcontrol_desc: 'Grey Aliens want to install a mind control device in a city. Help build it?',
  event_grey_crash_title: 'Crash Recovery',
  event_grey_crash_desc: 'A Grey scout ship crashed in the desert. Help recover the crew?',
  event_grey_terraform_title: 'Secret Terraforming',
  event_grey_terraform_desc: 'Grey Aliens are secretly terraforming an island. Provide resources?',
  event_grey_hack_title: 'Satellite Hack',
  event_grey_hack_desc: 'Grey Aliens want to hack Earth\'s satellite network. Provide access codes?',

  event_mib_raid_title: 'Alien Outpost Raid',
  event_mib_raid_desc: 'MIB is planning a raid on an alien outpost. Join the assault?',
  event_mib_safehouse_title: 'Safehouse Discovery',
  event_mib_safehouse_desc: 'MIB discovered a hidden Illuminati safehouse. Help raid it?',
  event_mib_weapons_title: 'Weapons Development',
  event_mib_weapons_desc: 'MIB is developing anti-alien weapons. Provide rare materials?',
  event_mib_evacuate_title: 'Civilian Evacuation',
  event_mib_evacuate_desc: 'MIB needs to evacuate civilians from an alien attack zone. Help?',
  event_mib_expose_title: 'Corruption Exposed',
  event_mib_expose_desc: 'MIB wants to expose Illuminati corruption to the public. Leak the documents?',

  // Shadow Contact (mid-game ad choices)
  sc_title: 'Shadow Contact',
  sc_accept: 'Accept Deal',
  sc_decline: 'Decline',
  sc_offer_intel: 'Intelligence Report',
  sc_offer_intel_desc: 'A deep-cover mole offers classified intel worth {amount} \u{1F6F8}',
  sc_offer_serum: 'Experimental Serum',
  sc_offer_serum_desc: 'An alien lab sample that amplifies tap power x10 for 30 seconds',
  sc_offer_tech: 'Black Market Tech',
  sc_offer_tech_desc: 'Stolen alien technology that boosts income x10 for 30 seconds',
  sc_offer_docs: 'Classified Cache',
  sc_offer_docs_desc: 'A hidden stash containing 3 Classified Documents \u{1F4DC}',

  // Boss warning & tutorial
  boss_warning: 'WARNING',
  boss_warning_sub: 'A powerful enemy is approaching...',
  boss_tutorial_title: 'Boss Fight!',
  boss_tutorial_text: 'A boss has appeared! Tap rapidly to deal damage before time runs out.<br><br>Defeat bosses to earn <b>IP, Docs, and Agent Cards</b>!<br>Watch an ad for <b>2x damage</b> boost.',
  // === Infiltration Run (generated) ===
  tab_infiltration: "Infiltrate",
  infil_eyebrow: "INFILTRATION OPS",
  infil_title: "Infiltration Run",
  infil_subtitle: "Slip in, climb the ranks, get out clean.",
  infil_tutorial_note: "First run: learn the ropes. Chasing the top rank too hard gets you caught.",
  infil_agent_stats: "Agent Stats",
  infil_highest_career: "Best Career",
  infil_total_runs: "Total Runs",
  infil_total_success: "Successes",
  infil_tradeoff_hint: "Safe = small reward, low rank. Greedy = high detection, high risk. Weigh every choice.",
  infil_start: "Start Infiltration",
  infil_start_tutorial: "Start Tutorial Run",
  infil_cooldown: "Cooldown",
  infil_cancel: "Cancel",
  infil_detection: "Detection",
  infil_step: "Event",
  infil_difficulty: "Diff",
  infil_selecting: "Selecting",
  infil_choice_success: "SUCCESS",
  infil_choice_fail: "FAILED",
  infil_roll: "Roll",
  infil_next: "Next",
  infil_to_extraction: "To Extraction",
  infil_extraction_cat: "FINAL STEP",
  infil_extraction_title: "Extraction",
  infil_extraction_desc: "All events cleared. Slip out now — the lower your detection, the safer.",
  infil_attempt_extraction: "Attempt Extraction",
  infil_final_chance: "Extraction Chance",
  infil_result_success: "INFILTRATION SUCCESS",
  infil_result_fail: "CAUGHT",
  infil_result_success_sub: "You slipped out and secured a cover career.",
  infil_result_fail_sub: "Security caught you. Nothing gained this time.",
  infil_docs: "Docs",
  infil_cleared: "Cleared",
  infil_career_earned: "Career Secured",
  infil_fail_note: "No reward. A short cooldown before the next run.",
  infil_retry_ad: "Watch Ad: Second Chance",
  infil_retry_title: "Second Chance",
  infil_retry_desc: "Watch a short ad to lower your detection and retry the extraction once.",
  infil_retry_confirm: "Watch Ad",
  infil_close: "Close",
  infil_stat_disguise: "Disguise",
  infil_stat_combat: "Combat",
  infil_stat_hacking: "Hacking",
  infil_stat_charisma: "Charisma",
  infil_stat_none: "No Check",
  infil_tag_safe: "SAFE",
  infil_tag_risky: "RISKY",
  infil_tag_aggressive: "ALL-IN",
  infil_career_cleaner: "Cleaner",
  infil_career_guard: "Guard",
  infil_career_clerk: "Clerk",
  infil_career_manager: "Manager",
  infil_career_executive: "Executive",
  infil_career_director: "Director",
  infil_career_warrior: "Warrior",
  infil_career_none: "None",
  infil_ev_patrol_cat: "Infiltration Case / Corporate State",
  infil_ev_patrol_title: "Patrol Approaching",
  infil_ev_patrol_desc: "A security patrol is heading straight for you. How do you react?",
  infil_ch_patrol_a_label: "Wait in the shadows",
  infil_ch_patrol_a_desc: "Hold your breath until they pass. Safe, but you lose time.",
  infil_ch_patrol_b_label: "Greet them as staff",
  infil_ch_patrol_b_desc: "Nod politely in your cover identity and walk past.",
  infil_ch_patrol_c_label: "Take them down",
  infil_ch_patrol_c_desc: "Ambush the patrol and force through. Big reward, big risk.",
  infil_ev_security_check_cat: "Infiltration Case / Corporate State",
  infil_ev_security_check_title: "Security Checkpoint",
  infil_ev_security_check_desc: "A manned checkpoint blocks the corridor ahead.",
  infil_ch_security_check_a_label: "Find a side route",
  infil_ch_security_check_a_desc: "Quietly slip down an adjacent passage.",
  infil_ch_security_check_b_label: "Show forged pass",
  infil_ch_security_check_b_desc: "Present a well-made forged access pass.",
  infil_ch_security_check_c_label: "Hack the scanner",
  infil_ch_security_check_c_desc: "Breach the scanner terminal and kill the alarm.",
  infil_ev_informant_cat: "Infiltration Case / Corporate State",
  infil_ev_informant_title: "Recruit an Informant",
  infil_ev_informant_desc: "An insider might hand over classified files — for a price.",
  infil_ch_informant_a_label: "Take the anonymous tip",
  infil_ch_informant_a_desc: "Check the drop box without making contact.",
  infil_ch_informant_b_label: "Persuade the insider",
  infil_ch_informant_b_desc: "Win over the staffer with smooth talk.",
  infil_ch_informant_c_label: "Strong-arm the files",
  infil_ch_informant_c_desc: "Threaten them into surrendering the data.",
  infil_ev_cctv_cat: "Infiltration Case / Corporate State",
  infil_ev_cctv_title: "Bypass the CCTV",
  infil_ev_cctv_desc: "A ceiling of cameras sweeps the whole hall.",
  infil_ch_cctv_a_label: "Move through blind spots",
  infil_ch_cctv_a_desc: "Creep slowly along the camera blind spots.",
  infil_ch_cctv_b_label: "Loop the feed",
  infil_ch_cctv_b_desc: "Splice a fake loop into the surveillance feed.",
  infil_ch_cctv_c_label: "Smash the cameras",
  infil_ch_cctv_c_desc: "Wreck the cameras and rush past.",
  infil_ev_fake_id_cat: "Infiltration Case / Corporate State",
  infil_ev_fake_id_title: "ID Inspection",
  infil_ev_fake_id_desc: "Guards are checking every ID in a long queue.",
  infil_ch_fake_id_a_label: "Leave the queue",
  infil_ch_fake_id_a_desc: "Quietly drop out and find another way.",
  infil_ch_fake_id_b_label: "Present forged ID",
  infil_ch_fake_id_b_desc: "Pass the checkpoint with a crafted forgery.",
  infil_ch_fake_id_c_label: "Sweet-talk the guard",
  infil_ch_fake_id_c_desc: "Talk your way past with slick charm.",
  infil_ev_parking_cat: "Infiltration Case / Corporate State",
  infil_ev_parking_title: "Underground Parking",
  infil_ev_parking_desc: "The garage is your way in, but a guard patrols it.",
  infil_ch_parking_a_label: "Hide behind vehicles",
  infil_ch_parking_a_desc: "Tuck yourself between parked cars.",
  infil_ch_parking_b_label: "Neutralize the guard",
  infil_ch_parking_b_desc: "Silently subdue the garage guard.",
  infil_ch_parking_c_label: "Pose as valet",
  infil_ch_parking_c_desc: "Steal a valet uniform and stroll in.",
  infil_ev_server_room_cat: "Infiltration Case / Corporate State",
  infil_ev_server_room_title: "Server Room Breach",
  infil_ev_server_room_desc: "The core data sits behind a hardened server-room door.",
  infil_ch_server_room_a_label: "Crawl the vents",
  infil_ch_server_room_a_desc: "Take the narrow vents. Slow but safe.",
  infil_ch_server_room_b_label: "Seize admin access",
  infil_ch_server_room_b_desc: "Hijack admin rights to open the room.",
  infil_ch_server_room_c_label: "Force the door",
  infil_ch_server_room_c_desc: "Rip open the security door and barge in.",
  infil_ev_board_meeting_cat: "Infiltration Case / Corporate State",
  infil_ev_board_meeting_title: "Board Meeting Infiltration",
  infil_ev_board_meeting_desc: "Top executives are trading secrets behind closed doors.",
  infil_ch_board_meeting_a_label: "Eavesdrop from the hall",
  infil_ch_board_meeting_a_desc: "Listen quietly from outside the room.",
  infil_ch_board_meeting_b_label: "Pose as consultant",
  infil_ch_board_meeting_b_desc: "Blend in as an outside consultant.",
  infil_ch_board_meeting_c_label: "Storm the room",
  infil_ch_board_meeting_c_desc: "Raid the room and seize every secret. Warrior play.",
  infil_ev_reporter_cat: "Infiltration Case / Corporate State",
  infil_ev_reporter_title: "Shake the Reporter",
  infil_ev_reporter_desc: "A dogged journalist is tailing your every move.",
  infil_ch_reporter_a_label: "Blend into the crowd",
  infil_ch_reporter_a_desc: "Melt into a busy street to lose the tail.",
  infil_ch_reporter_b_label: "Change disguise",
  infil_ch_reporter_b_desc: "Swap outerwear and reverse direction.",
  infil_ch_reporter_c_label: "Feed false leads",
  infil_ch_reporter_c_desc: "Approach first and plant fake information.",
  infil_ev_party_cat: "Infiltration Case / Corporate State",
  infil_ev_party_title: "Crash the Party",
  infil_ev_party_desc: "A gala hides the people you need to reach.",
  infil_ch_party_a_label: "Carry a waiter tray",
  infil_ch_party_a_desc: "Grab an empty tray and pose as service.",
  infil_ch_party_b_label: "Pose as a guest",
  infil_ch_party_b_desc: "Mingle smoothly as an invited guest.",
  infil_ch_party_c_label: "Enter as a VIP",
  infil_ch_party_c_desc: "Dress as a VIP and stride through the front.",
  infil_ev_drone_cat: "Infiltration Case / Corporate State",
  infil_ev_drone_title: "Drone Surveillance",
  infil_ev_drone_desc: "A surveillance drone sweeps the open yard.",
  infil_ch_drone_a_label: "Wait under cover",
  infil_ch_drone_a_desc: "Hide beneath a structure until it passes.",
  infil_ch_drone_b_label: "Jam the signal",
  infil_ch_drone_b_desc: "Jam its comms and blind the drone.",
  infil_ch_drone_c_label: "Shoot it down",
  infil_ch_drone_c_desc: "Down the drone. Sure, but it leaves traces.",
  infil_ev_guard_shift_cat: "Infiltration Case / Corporate State",
  infil_ev_guard_shift_title: "Guard Shift Change",
  infil_ev_guard_shift_desc: "A shift change opens a brief window in the watch.",
  infil_ch_guard_shift_a_label: "Wait for the swap",
  infil_ch_guard_shift_a_desc: "Wait for the gap and move on the change.",
  infil_ch_guard_shift_b_label: "Pose as relief guard",
  infil_ch_guard_shift_b_desc: "Walk into the post as the relief guard.",
  infil_ch_guard_shift_c_label: "Ambush the guard",
  infil_ch_guard_shift_c_desc: "Jump the guard just before the swap.",
  infil_ev_vault_cat: "Infiltration Case / Corporate State",
  infil_ev_vault_title: "The Secret Vault",
  infil_ev_vault_desc: "A hidden vault holds the crown-jewel documents.",
  infil_ch_vault_a_label: "Skip the vault",
  infil_ch_vault_a_desc: "Leave the vault and grab only your target.",
  infil_ch_vault_b_label: "Crack the e-lock",
  infil_ch_vault_b_desc: "Hack the electronic lock and open it.",
  infil_ch_vault_c_label: "Blow the vault",
  infil_ch_vault_c_desc: "Blast it open and grab everything. Top reward.",
  infil_ev_vaccine_cat: "Infiltration Case / Corporate State",
  infil_ev_vaccine_title: "Vaccination Cover",
  infil_ev_vaccine_desc: "A pop-up clinic is the perfect cover to get inside.",
  infil_ch_vaccine_a_label: "Join the queue",
  infil_ch_vaccine_a_desc: "Line up as an ordinary patient.",
  infil_ch_vaccine_b_label: "Wear a medic gown",
  infil_ch_vaccine_b_desc: "Put on a medic gown and walk inside.",
  infil_ch_vaccine_c_label: "Impersonate the chief",
  infil_ch_vaccine_c_desc: "Pose as the director and dismiss the staff.",
  infil_ev_broadcast_cat: "Infiltration Case / Corporate State",
  infil_ev_broadcast_title: "Broadcast Control Room",
  infil_ev_broadcast_desc: "The station feed could carry your message — or your evidence.",
  infil_ch_broadcast_a_label: "Read the logs",
  infil_ch_broadcast_a_desc: "Quietly review the broadcast logs only.",
  infil_ch_broadcast_b_label: "Intercept the feed",
  infil_ch_broadcast_b_desc: "Hack the feed and siphon the data.",
  infil_ch_broadcast_c_label: "Pose as live director",
  infil_ch_broadcast_c_desc: "Impersonate the live director and take the room.",
  infil_ev_border_cat: "Infiltration Case / Corporate State",
  infil_ev_border_title: "Border Checkpoint",
  infil_ev_border_desc: "A guarded border stands between you and the target.",
  infil_ch_border_a_label: "Take an unwatched trail",
  infil_ch_border_a_desc: "Cross via an unmonitored back trail.",
  infil_ch_border_b_label: "Persuade the officer",
  infil_ch_border_b_desc: "Talk the inspector out of suspicion.",
  infil_ch_border_c_label: "Pose as a diplomat",
  infil_ch_border_c_desc: "Cross under a diplomatic cover identity.",
  infil_ch_border_d_label: "Ram the barrier",
  infil_ch_border_d_desc: "Smash the barrier with a vehicle and floor it.",
} as const;
